import { render } from "./guide-page.vue?vue&type=template&id=66eaab3e&scoped=true"
import script from "./guide-page.vue?vue&type=script&lang=js"
export * from "./guide-page.vue?vue&type=script&lang=js"

import "./guide-page.vue?vue&type=style&index=0&id=66eaab3e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66eaab3e"]])

export default __exports__